import About from "./components/About";
import Contact from "./components/Contact";
import Experience from "./components/Experience";
import Home from "./components/Home";
import NavBar from "./components/NavBar";
import Resume from "./components/Resume";
import Projects from "./components/Projects";
import SocialLinks from "./components/SocialLinks";
import Footer from "./components/Footer";
import CursorGlow from "./components/CursorGlow";
function App() {
  return (
   <div>

      <CursorGlow />
      <NavBar />
      <Home />
      <SocialLinks />
      <About />
      <Projects />
      <Experience />
      <Resume />
      <Contact />
      <Footer />
      
    </div>
  );
};

export default App;
